import { render, staticRenderFns } from "./CommonProblemDetails.vue?vue&type=template&id=1d25fb0f&scoped=true"
import script from "./CommonProblemDetails.vue?vue&type=script&lang=js"
export * from "./CommonProblemDetails.vue?vue&type=script&lang=js"
import style0 from "./CommonProblemDetails.vue?vue&type=style&index=0&id=1d25fb0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25fb0f",
  null
  
)

export default component.exports